import useBacktestStore from '../Store/backtestStore';

let ws = null;

export function connectBacktestWs() {
  // const WS_URL = 'ws://localhost:4001/ws';
  const WS_URL = 'wss://one-dte-iron-condor-backend-22b99d211e32.herokuapp.com/ws';

  if (ws) {
    console.warn('[GEMIC WS] Already connected');
    return () => {};
  }

  const socket = new WebSocket(WS_URL);
  ws = socket;

  socket.onopen = () => {
    console.log('[GEMIC WS] Connected');

    // Request GEMIC equity/performance series from backend
    socket.send(JSON.stringify({
      type: 'get_gemic_equity'
    }));
  };

  socket.onmessage = (event) => {
    let msg;

    try {
      msg = JSON.parse(event.data);
    } catch (err) {
      console.warn('[GEMIC WS] Failed to parse message:', event.data);
      return;
    }

    if (msg.type === 'gemic_equity') {
      const series = Array.isArray(msg.equitySeries)
        ? msg.equitySeries
        : [];

      console.log('[GEMIC WS] Equity rows received:', series.length);

      useBacktestStore
        .getState()
        .setEquitySeries(series);
    }
  };

  socket.onerror = (err) => {
    console.error('[GEMIC WS] Error:', err);
  };

  socket.onclose = () => {
    console.log('[GEMIC WS] Disconnected');
    ws = null;
  };

  return () => {
    try {
      socket.close();
    } catch (_) {}

    if (ws === socket) ws = null;
  };
}
